import { render } from "./ParallaxEffect.vue?vue&type=template&id=06c63558&scoped=true"
import script from "./ParallaxEffect.vue?vue&type=script&lang=js"
export * from "./ParallaxEffect.vue?vue&type=script&lang=js"

import "./ParallaxEffect.vue?vue&type=style&index=0&id=06c63558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c63558"]])

export default __exports__